import gql from 'graphql-tag';

export const createUser = gql`
  mutation createUser(
    $email: String!
    $firstName: String!
    $lastName: String!
    $password: String!
    $brandName: String
  ) {
    createUser(
      email: $email
      firstName: $firstName
      lastName: $lastName
      password: $password
      brandName: $brandName
    ) {
      status
      firstName
      lastName
      validateEmailUrl
    }
  }
`;

export const emailValidation = gql`
  mutation emailValidation($token: String!, $pin: Int!, $tokenType: String!) {
    emailValidation(token: $token, pin: $pin, tokenType: $tokenType) {
      status
      attempt
      maxAttempt
      reason
    }
  }
`;

export const resendValidation = gql`
  mutation resendValidation($oldToken: String!, $tokenType: String!) {
    resendValidation(oldToken: $oldToken, tokenType: $tokenType) {
      validateEmailUrl
    }
  }
`;
